import { FileText } from "lucide-react";
import type { ReactNode } from "react";

interface EmptyReportsStateProps {
  projectName: string;
  action?: ReactNode;
}

export function EmptyReportsState({
  projectName,
  action,
}: EmptyReportsStateProps) {
  return (
    <div className="flex h-full w-full items-center justify-center px-10 py-12">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-muted">
          <FileText className="h-12 w-12 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">No reports yet</h3>
          <p className="text-sm text-muted-foreground">
            Build your first report for {projectName} from the photos or issues
            you pick. It stays here, so you can export it again later.
          </p>
        </div>
        {action}
      </div>
    </div>
  );
}
